import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'languagePreview', pure: false,
    standalone: false
})
export class LanguagePreviewPipe implements PipeTransform {
    transform(value: any[], propertyName: string, languageCode = 'en', languagePropertyName = 'languageCode') {
        return Array.isArray(value) ? value.find(language => language?.[languagePropertyName] === languageCode)?.[propertyName] : null;
    }
}
